import { CircleAlert, SearchX, ShieldX, WifiOff } from 'lucide-react';
import { EmptyState } from './empty-state.jsx';
import { Button } from './button.jsx';

/**
 * Friendly rendering of a failed query (duck-typed ProblemError):
 * 404 → „nicht gefunden“, 403 → „keine Berechtigung“, network → „keine Verbindung“, else generic + retry.
 * @param {{
 *   error: any,
 *   onRetry?: () => void,
 *   notFoundTitle?: string,
 *   notFoundDescription?: string,
 *   action?: import('react').ReactNode,
 *   compact?: boolean,
 *   className?: string,
 * }} props
 */
export function ErrorState({ error, onRetry, notFoundTitle = 'Nicht gefunden', notFoundDescription, action, compact = false, className }) {
  const status = error?.status;
  if (status === 404) {
    return (
      <EmptyState
        compact={compact}
        className={className}
        icon={SearchX}
        title={notFoundTitle}
        description={notFoundDescription ?? 'Der Eintrag existiert nicht (mehr) oder ist für Sie nicht sichtbar.'}
        action={action}
      />
    );
  }
  if (status === 403) {
    return (
      <EmptyState
        compact={compact}
        className={className}
        icon={ShieldX}
        title="Keine Berechtigung"
        description={error?.detail || 'Für diese Daten fehlt Ihnen die Berechtigung.'}
        action={action}
      />
    );
  }
  const network = status === 0;
  return (
    <EmptyState
      compact={compact}
      className={className}
      icon={network ? WifiOff : CircleAlert}
      title={network ? 'Keine Verbindung zum Server' : 'Daten konnten nicht geladen werden'}
      description={network ? 'Bitte prüfen Sie Ihre Internetverbindung.' : error?.detail || error?.title || error?.message || undefined}
      action={
        onRetry ? (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Erneut versuchen
          </Button>
        ) : (
          action
        )
      }
    />
  );
}
